import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { withSuspense } from './utils';
import type { RouteConfig } from './types';

// ============================================================================
// Admin Components
// ============================================================================

// Login page is now lazy-loaded to reduce bundle size
const AdminLoginPageNew = withSuspense(lazy(() => import('@/features/admin/auth/pages/AdminLoginPageNew')));

// Lazy-loaded admin components
const AdminLayout = withSuspense(lazy(() => import('@/features/admin/templates/AdminLayoutNew')));
const NotFoundPage = withSuspense(lazy(() => import('@/pages/NotFoundPage')));

// ============================================================================
// Admin Routes Configuration
// ============================================================================

export const adminRoutes: RouteConfig[] = [
    // Login
    {
        path: '/login',
        element: <AdminLoginPageNew />,
        meta: { title: 'Admin Login' }
    },

    // Dashboard & Admin Pages
    {
        path: '/dashboard/*',
        element: <AdminLayout />,
        meta: {
            title: 'Admin Dashboard',
            requiresAuth: true,
            requiredRole: 'admin'
        }
    },

    // Default redirect for admin subdomain
    {
        path: '/',
        element: <Navigate to="/login" replace />,
        meta: { title: 'Admin' }
    },

    // 404 - Must be last
    {
        path: '*',
        element: <NotFoundPage />,
        meta: { title: 'Página no encontrada' }
    },
];
